export default __webpack_public_path__ + "static/media/dashboardNew.40752973.svg";